function initialize() {

    var feedbackFormSelector = ".feedback-form";
    $(feedbackFormSelector).submit(function(){
        if($(feedbackFormSelector).parsley("validate").isValid()){
            validateFormAndDisableButton(feedbackFormSelector, '.override-form-btn');
        }
    });
}

function validateFormAndDisableButton(form, button){
    if($(form).parsley("validate").isValid()){
        $(button).prop('disabled', true);
    }
}

module.exports = {
    initialize: initialize
};